export function showURL(studentID) {
  // console.log("studentData !?", studentID);
  let yearId = studentID.slice(0, 2);
  let url = `http://datasoft.co.th/mvc_eye_depart/images/student/${yearId}/${studentID}.jpg`;

  return url;
}
